import React from 'react';
import { ShieldCheck, Star, ShieldAlert, BadgeCheck, Shield } from 'lucide-react';
import './TrustStrip.css';

const TrustStrip = () => {
  return (
    <div className="trust-strip-wrapper container">
      <div className="trust-strip">
        <div className="trust-strip-left">
          <span className="trust-badge">
            <ShieldCheck size={18} className="badge-icon text-green" /> 
            <span className="text-yellow">TRUST STRIP:</span>
          </span>
          <span className="trust-item"><ShieldCheck size={14} className="item-icon"/> 100% Verified Auditions</span>
          <span className="trust-separator">·</span>
          <span className="trust-item"><ShieldAlert size={14} className="item-icon"/> No Fake Opportunities</span>
          <span className="trust-separator">·</span>
          <span className="trust-item"><BadgeCheck size={14} className="item-icon text-yellow"/> Secure Payments</span>
          <span className="trust-separator">·</span>
          <span className="trust-item"><Shield size={14} className="item-icon"/> Privacy Protected</span>
        </div>
        <div className="trust-strip-right">
          <span className="trust-score text-yellow">4.9/5</span>
          <div className="trust-stars">
            {[...Array(5)].map((_, i) => <Star key={i} size={14} fill="#FFD700" color="#FFD700" />)}
          </div>
          <span className="trust-reviews">Based on<br/>2,000+ Reviews</span>
        </div>
      </div>
    </div>
  );
};

export default TrustStrip;
